module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image15i.fb755aa6.jpg";